import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

const DEFAULT_KANBAN_DATA = { columns: [], totalLoanCount: 0, isLoading: false, error: null };

const selectKanbanState = ({ loanPipelines }) => loanPipelines.kanbanData;

export const selectKanbanData = memoizeOne(pipelineId =>
  createSelector([selectKanbanState], kanbanData => kanbanData[pipelineId] || DEFAULT_KANBAN_DATA),
);
